var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoriteWhite({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.6361 9.22766C21.7886 9.34582 21.9033 9.50543 21.9664 9.68716C22.0149 9.86885 22.0107 10.0605 21.9541 10.2399C21.8975 10.4193 21.791 10.579 21.6468 10.7005L17.5224 14.6746L18.521 20.3177C18.5567 20.504 18.538 20.6965 18.4672 20.8725C18.3965 21.0486 18.2765 21.2008 18.1216 21.3112C17.9502 21.4346 17.7439 21.5007 17.5324 21.5C17.3715 21.5005 17.2132 21.4594 17.073 21.3808L11.9799 18.7182L6.86691 21.3708C6.7029 21.4573 6.5179 21.4967 6.33268 21.4844C6.14746 21.4721 5.96935 21.4087 5.81834 21.3013C5.6634 21.1909 5.54346 21.0387 5.47268 20.8626C5.4019 20.6866 5.38323 20.494 5.41888 20.3078L6.41752 14.6646L2.29313 10.6906C2.16477 10.5632 2.0737 10.4034 2.02972 10.2283C1.98574 10.0533 1.99049 9.86964 2.04347 9.6971C2.10135 9.52052 2.20783 9.36363 2.35081 9.24421C2.49378 9.1248 2.66755 9.04764 2.85237 9.02151L8.53464 8.18696L11.0812 3.06045C11.1629 2.89248 11.2906 2.75081 11.4496 2.65169C11.6085 2.55257 11.7923 2.5 11.9799 2.5C12.1676 2.5 12.3514 2.55257 12.5103 2.65169C12.6693 2.75081 12.797 2.89248 12.8787 3.06045L15.4253 8.1969L21.1075 9.02151C21.3001 9.0379 21.4837 9.10951 21.6361 9.22766Z",
    fill: "#fff"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoriteWhite);
export default __webpack_public_path__ + "static/media/favorite-white.a75fea51004a78901fc9d1ec7bc37281.svg";
export { ForwardRef as ReactComponent };